import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import { jobStatusTranslationKeys } from '@core/offers-types';
import type { JobData } from '@core/tellent-assistant-types';
import { AppKind } from '@core/tellent-types';
import { IconContainerComponent } from '@core/user-interface-legacy';

import { injectAssistantEntityUrl } from '../../assistant-entity-url';
import { ListCardComponent } from '../../list-card/list-card.component';

@Component({
  selector: 'rt-list-item-job',
  imports: [ListCardComponent, IconContainerComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-job.component.html',
  styleUrl: './list-item-job.component.less',
})
export class ListItemJobComponent {
  private readonly i18n = inject(I18nService);
  private readonly entityUrl = injectAssistantEntityUrl();

  protected readonly statusLabel = computed(() =>
    this.i18n.translate(jobStatusTranslationKeys[this.data().status]),
  );
  protected readonly url = computed(() =>
    this.entityUrl(AppKind.Recruitee, { id: 'offer', params: { offerId: this.data().slug } }),
  );

  public readonly data = input.required<JobData>();
}
